import { useContext } from "react";
import styled from "styled-components";
import { hideScrollBar } from "../../../../../commonStyles";
import { ModalContext } from "../../../../Common/Modal";
import { FlexColumn } from "../../../../Common/Styles";
import { Followers } from "./Followers";
import { FollowersFollowingProps } from "./FollowersFollowing";
import { Following } from "./Following";

export const FollowModalContent = (
  props: FollowersFollowingProps.FollowModalContent
) => {
  const { type, filterText, searchInputId } = props;
  const { contentRef, maxContentHeight } = useContext(ModalContext);

  return (
    <Wrapper
      className="follow-modal-wrapper"
      ref={contentRef}
      $maxHeight={maxContentHeight}
    >
      <Content $gapInPx={8}>
        {type === "followers" ? (
          <Followers {...{ filterText, searchInputId }} />
        ) : (
          <Following {...{ filterText, searchInputId }} />
        )}
      </Content>
    </Wrapper>
  );
};

const Content = styled(FlexColumn)``;
const Wrapper = styled.div<{ $maxHeight: number }>`
  max-height: ${({ $maxHeight }) => $maxHeight}px;
  overflow: scroll;
  ${hideScrollBar}
`;
